var FeatureFlags;
(function(FeatureFlags) {
    FeatureFlags["ConfLeadCapture"] = "is_lead_capture_enabled";
    FeatureFlags["ConfLeadCaptureLicenseLimit"] = "lead_capture_license_limit";
    FeatureFlags["ConfInteractiveMaps"] = "is_interactive_maps_enabled";
    FeatureFlags["ConfVideoLibraryEnabled"] = "is_video_library_enabled";
    FeatureFlags["HidePrePrintedBadges"] = "hide_pre_printed_badges";
    FeatureFlags["OnsiteAppSessionRegistration"] = "onsite_app_session_registration";
    FeatureFlags["GroupRegistrationEnabled"] = "group_registration_enabled";
})(FeatureFlags || (FeatureFlags = {}));
export default FeatureFlags;
